// notification-item.component.ts
import { Component, Input, Output, EventEmitter, SecurityContext } from '@angular/core';
import { Notification } from '../notification.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-notification-item',
  // ❌ QUITAR standalone: true
  // standalone: true,
  // imports: [CommonModule],
  templateUrl: './notificationItem.html',
  styleUrls: ['./notificationItem.scss']
})
export class NotificationItemComponent {
  @Input() notification!: Notification;
  @Output() remove = new EventEmitter<string>();

  constructor(private sanitizer: DomSanitizer) {}

  handleAction(): void {
    if (this.notification.action) {
      this.notification.action.callback();
      this.remove.emit(this.notification.id);
    }
  }

  close(): void {
    this.remove.emit(this.notification.id);
  }

  getSafeIcon() {
    const icons = {
      // ✅ Checkmark simple pero con viewBox 0 0 24 24
      success: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>`,
      // ✅ X mark
      error: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`,
      // ✅ Info
      info: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="18" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`,
      // ✅ Warning
      warning: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4m0 4h.01"/><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`
    };
    const svg = icons[this.notification.type] || icons.info;
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}